import { useTranslations } from '@/i18n/use-translations';
import { useEventStore } from '@/state/stores/use-event-store';
import { AddOutlined } from '@mui/icons-material';
import { useRoleCount } from './hooks/use-role-count';
import { RoleProgressCounters } from './role-progress-counters';
import { ACTOR_ROLES } from '@/types/dtos/contributors/response/contributor.dto';
import { useNavigateToTab } from '../../../hooks/use-navigate-to';
import Widget from '@/components/common/widget.tsx';

export default function Actors({
  setActivateContributorInlineAdding,
}: {
  setActivateContributorInlineAdding: (value: boolean) => void;
}) {
  const t = useTranslations();
  const contributors = useEventStore((s) => s.contributors);
  const { contributorCount, roleCount, roleHeatmap } = useRoleCount(contributors, ACTOR_ROLES);
  const navigateToContributors = useNavigateToTab('contributors');

  const handleAddContributor = () => {
    // Set flag to activate inline adding and navigate
    setActivateContributorInlineAdding(true);
    navigateToContributors();
  };

  if (!contributors) return null;

  return (
    <Widget
      data-testid="event-actors"
      title={`${t('common.contributorCount', { count: contributorCount })} ${t('common.in')} ${t('common.roleCount', { count: roleCount })}`}
      primaryButton={{
        label: t('common.new'),
        onClick: handleAddContributor,
        testId: 'event-actors-add-actor-button',
        startIcon: <AddOutlined />,
      }}
    >
      <RoleProgressCounters roleHeatmap={roleHeatmap} />
    </Widget>
  );
}
